module.exports = __webpack_public_path__ + "img/empty_cart.a9cf18c.svg";